<template>
  <div>
    <b-button type="is-primary" @click="showModal = true" class="update-btn">
      <i class="mdi mdi-pencil"></i>
      Add
    </b-button>
    <b-modal
      v-model="showModal"
      :can-cancel="['escape', 'outside', 'button']"
      :width="420"
      trap-focus
    >
      <div class="modal-content">
        <!-- Work Experience Form -->
        <div v-if="type === 'work'">
          <h2 class="modal-title">
            <i class="mdi mdi-file-document-edit"></i>
            Update Profile
          </h2>
          <p class="modal-desc">
            Add new information or achievements to keep your profile up to date.
          </p>
          <b-field label="Profile Update">
            <b-input
              v-model="statsheetText"
              type="textarea"
              placeholder="Describe your update..."
              rows="4"
            ></b-input>
          </b-field>
          <div class="modal-actions">
            <b-button type="is-primary" :loading="loadingStatsheet" @click="updateStatsheet">
              Submit
            </b-button>
            <b-button type="is-text" @click="showModal = false">
              Cancel
            </b-button>
          </div>
        </div>
        <!-- Aspirations Form -->
        <div v-else-if="type === 'aspiration'">
          <h2 class="modal-title">
            <i class="mdi mdi-rocket-launch"></i>
            Update Aspirations
          </h2>
          <p class="modal-desc">
            Share your new goals or aspirations to help us support your career journey.
          </p>
          <b-field label="Aspirations Update">
            <b-input
              v-model="aspirationsText"
              type="textarea"
              placeholder="Describe your new aspiration..."
              rows="4"
            ></b-input>
          </b-field>
          <div class="modal-actions">
            <b-button type="is-primary" :loading="loadingAspirations" @click="updateAspirations">
              Submit
            </b-button>
            <b-button type="is-text" @click="showModal = false">
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { useUserStore } from '@/stores/userStore';

export default {
  name: 'AddUpdatesModal',
  props: {
    config: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      showModal: false,
      statsheetText: '',
      aspirationsText: '',
      loadingStatsheet: false,
      loadingAspirations: false
    };
  },
  created() {
    this.userStore = useUserStore()
  },
  methods: {
    async updateStatsheet() {
      this.loadingStatsheet = true;
      try {
        const updatedUser = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/update-statsheet`,
          { text: this.statsheetText },
          this.config
        );
        this.userStore.setUser(updatedUser.data);
        this.statsheetText = '';
        this.showModal = false;
      } catch (err) {
        this.$buefy.toast.open({
          message: 'Failed to update profile.',
          type: 'is-danger'
        });
      } finally {
        this.loadingStatsheet = false;
      }
    },
    async updateAspirations() {
      this.loadingAspirations = true;
      try {
        const updatedUser = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/update-aspirations`,
          { text: this.aspirationsText },
          this.config
        );
        this.userStore.setUser(updatedUser.data);
        this.aspirationsText = '';
        this.showModal = false;
      } catch (err) {
        this.$buefy.toast.open({
          message: 'Failed to update aspirations.',
          type: 'is-danger'
        });
      } finally {
        this.loadingAspirations = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.update-btn {
  margin-bottom: 1.5rem;
  font-weight: 700;
  font-size: 1.08rem;
  height: 3rem;
  border-radius: 0.7rem;
  background-color: $color-primary;
  color: $color-surface;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
  margin-top: -1rem;
  &:hover, &:focus {
    background: $color-primary;
    color: $color-surface;
  }
}

.modal-content {
  padding: 1.5rem 1rem;
  background: $color-surface;
  border-radius: 0.75rem;
  color: $color-text;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.modal-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: $color-primary;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.2rem;
  i {
    color: $color-warning;
    font-size: 1.7rem;
  }
}

.modal-desc {
  font-size: 1.05rem;
  color: $color-text-muted;
  margin-bottom: 0.5rem;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  justify-content: flex-end;
}
</style>
